export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}


//////////////////
// WEBPACK FOOTER
// ./~/uncontrollable/~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 2490
// module chunks = 0